import CopyRight from "./CopyRight";

export default CopyRight;
